"use strict";

PF.Form = class Form extends PF.Entity.Array {
    static get options() {
        return {
            dom: {
                element: undefined,
            },
            html: PF.Form.templates,
            modelConfig: {},
            model: undefined,
            fieldsConfig: {},
            keyPrefix: '',
            errors: {
                required: "Заполните обязательные поля",
                hasInvalid: "Проверьте правильность заполнения данных"
            },
            submitPfId: 'submit',
            saveOnSubmit: true,
            error: '',
            toastOnSave: true,
            toastOnSaveText: 'Данные успешно сохранены',
            notModifyBehavior: 'hide', //none, hide, disable,

            speech: app.speech,
        };
    }

    static get templates() {



        return {
            //language=HTML
            preloader: `
				<div class="pf-form-preloader-container" pf="preloader">
					<div class="preloader">
						<span class="preloader-inner">
						 <span class="preloader-inner-gap"></span>
						 <span class="preloader-inner-left">
							  <span class="preloader-inner-half-circle"></span>
						 </span>
						 <span class="preloader-inner-right">
							  <span class="preloader-inner-half-circle"></span>
						 </span>
					  </span>
					</div>
				</div>
			`
        };
    }

    init() {
        this.dom.loads(this.html);
        if (this.model === undefined) {
            this.model = new PF.Model(this.modelConfig);
        } else {
            PF.Options.assignOptions(this.model, this.modelConfig);
        }
        this.dom.process(this.dom.element);
        this.dom.element.addClass('pf-form');
        this.dom.element.after(this.dom.preloader);

        this.bindDom({ element: 'show', preloader: 'hide' }, ['model.options.loadStatus', 'fieldsInited'], (s, i) => {
            return s === 'loaded' && i === true;
        });

        this.model.onValueOnce('options.loadStatus', 'loaded', () => this.initFields());
        if (this.toastOnSave === true) {
            this.model.on('save-success', () => app.toast(this.toastOnSaveText));
        }
        this.model.options.form = this;

        if (this.dom[this.submitPfId] !== undefined) {
            this.submitButton = new PF.ButtonSubmit({
                dom: { element: this.dom[this.submitPfId] },
                errorPointer: { object: this, key: 'error' }
            });
            // this.submitButton.on('submit', (e) => this.domSubmit(e));

            if (this.notModifyBehavior === 'hide') {
                this.bindDom({
                    [this.submitPfId]: 'show'
                }, 'model.options.hasModify');
            }
            if (this.notModifyBehavior === 'disable') {
                this.submitButton.calc('enabled', { object: this.model, key: 'hasModify' }, (m) => m);
            }
        }

        this.dom.element.on('submit', (e) => this.domSubmit(e));
        this.on('trySubmit', () => this.trySubmit());
    }

    initFields() {
        this.fields = {};
        for (let fieldName in this.fieldsConfig) {
            // if (this.dom[fieldName] !== undefined) {
                let fieldConfig = this.fieldsConfig[fieldName];
                fieldConfig.form = this;
                fieldConfig.key = PF.H.get(fieldConfig, 'key', fieldName);
                // fieldConfig.key = this.keyPrefix + "." + fieldConfig.key;
                fieldConfig.key = this.keyPrefix + fieldConfig.key;

                fieldConfig.dom = fieldConfig.dom || {};
                fieldConfig.dom.element = this.dom[fieldName];
                fieldConfig.model = this.model;

                this.fields[fieldName] = new fieldConfig.class(fieldConfig);
            // }
        }
        this.fieldsInited = true;
        this.trigger('fields-inited');
    }

    domSubmit(event) {
        event.preventDefault();
        this.trySubmit();
    }

    validate(silent) {
        let valid = true;
        for (let fieldName in this.fields) {
            if (!this.fields[fieldName].validate(silent)) {
                valid = false;
            }
        }
        return valid;
    }

    trySubmit() {
        this.error = '';
        if (this.validate(false) === true) {
            this.submit();
        } else {
            this.error = this.errors.hasInvalid;
        }
    }

    submit() {
        this.trigger('before-submit');
        if (this.saveOnSubmit === true) {
            this.model.save();
        }
        this.trigger('submit');
    }

    setError(error) {
        this.submitButton.error = this.errors[error];
    }
};